const LK_DOCUMENT_ORIGIN = 'https://lk.xbadm.ru'

export function stripEmptyParams(obj) {
  const out = {}
  Object.keys(obj || {}).forEach(k => {
    const v = obj[k]
    if (v === '' || v === null || v === undefined) return
    if (typeof v === 'string' && v.trim() === '') return
    out[k] = v
  })
  return out
}

export function buildLkDocumentHref(url) {
  if (url == null || url === '') return null
  const s = String(url).trim()
  if (!s) return null
  try {
    if (/^https?:\/\//i.test(s)) {
      const u = new URL(s)
      return `${LK_DOCUMENT_ORIGIN}${u.pathname}${u.search}${u.hash}`
    }
    const path = s.startsWith('/') ? s : `/${s}`
    return `${LK_DOCUMENT_ORIGIN}${path}`
  } catch (e) {
    return s
  }
}

export function formatDateTime(val) {
  if (val == null || val === '') return '—'
  try {
    const d = new Date(val)
    if (!Number.isNaN(d.getTime())) {
      const dd = String(d.getDate()).padStart(2, '0')
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const yyyy = String(d.getFullYear())
      const hh = String(d.getHours()).padStart(2, '0')
      const min = String(d.getMinutes()).padStart(2, '0')
      return `${dd}.${mm}.${yyyy} ${hh}:${min}`
    }
  } catch (e) { /* noop */ }
  return String(val)
}

export function formatLogActor(logItem) {
  const name = logItem && logItem.performed_by_name
  if (name && String(name).trim()) return name
  const actorId = logItem && logItem.performed_by_id
  if (actorId !== null && actorId !== undefined && actorId !== '') return `ID ${actorId}`
  return 'Система'
}

export function formatLogSubject(logItem) {
  if (!logItem || typeof logItem !== 'object') return '—'
  const parts = []
  if (logItem.user_benefit_id) {
    const category = logItem.user_benefit_category ? ` (${logItem.user_benefit_category})` : ''
    parts.push(`Льгота #${logItem.user_benefit_id}${category}`)
  }
  if (logItem.benefit_request_id) {
    const category = logItem.benefit_request_category ? ` (${logItem.benefit_request_category})` : ''
    parts.push(`Заявка #${logItem.benefit_request_id}${category}`)
  }
  return parts.length ? parts.join(' | ') : '—'
}

export function formatDate(val) {
  if (val == null || val === '') return '—'
  try {
    const d = new Date(val)
    if (!Number.isNaN(d.getTime())) {
      const dd = String(d.getDate()).padStart(2, '0')
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const yyyy = String(d.getFullYear())
      return `${dd}.${mm}.${yyyy}`
    }
  } catch (e) { /* noop */ }
  return String(val)
}

export function isExpired(dateStr) {
  if (!dateStr) return false
  try {
    return new Date(dateStr) < new Date()
  } catch (e) {
    return false
  }
}

export function isValidIsoDate(value) {
  if (!value || typeof value !== 'string') return false
  const text = value.trim()
  if (!/^\d{4}-\d{2}-\d{2}$/.test(text)) return false
  const [year, month, day] = text.split('-').map(Number)
  const date = new Date(Date.UTC(year, month - 1, day))
  return date.getUTCFullYear() === year
    && date.getUTCMonth() === month - 1
    && date.getUTCDate() === day
}

export function isoDateRangeError(from, to) {
  if (!from || !to) return []
  if (!isValidIsoDate(from) || !isValidIsoDate(to)) return []
  return from <= to ? [] : ['Дата окончания не может быть раньше даты начала']
}
